"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyQuestionError = void 0;
class EmptyQuestionError extends Error {
    constructor(emptyQuestions, emptyAnswers) {
        super('Quiz has empty questions or answers');
        this.name = 'EmptyQuestionError';
        this.scope = {
            emptyQuestions,
            emptyAnswers
        };
    }
}
exports.EmptyQuestionError = EmptyQuestionError;
